__turbopack_context__.v({
  "activeDefault": "styles-module-scss-module__7FQOPa__activeDefault",
  "activeGoldCoins": "styles-module-scss-module__7FQOPa__activeGoldCoins",
  "activeSweep": "styles-module-scss-module__7FQOPa__activeSweep",
  "ico": "styles-module-scss-module__7FQOPa__ico",
  "root": "styles-module-scss-module__7FQOPa__root",
});
